import React, { useState, useEffect } from "react";
import Footer from "../component/Footer/FooterCommon";
import CompanySelect from "../component/Common/CountrySelect";
import { Download } from "lucide-react";
import PolicyCard from "../component/Policies/PolicyCard";
import Navbar from "../component/Navbar/NavbarCommon";
import { useNavigate } from "react-router-dom";
import DashboardItem from "../component/SelectDashboardSmith&Pureit/DashboardItem";
import { useAccountStore } from "../store/useAccountStore";
import { getLinksByCompany } from "../utils/redirectUtils";
// import ChatWidget from "../component/ChatWidget/ChatWidget";

const Dashboard = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { user } = useAccountStore();
  const data = [
    {
      title: "HRIS",
      description: "Know your earned, sick, casual, and optional leaves.",
      icon: "📄",
    },
    {
      title: "Emp Sales",
      description: "Policies for business travel and reimbursement.",
      icon: "✈️",
    },
    {
      title: "Org Charts",
      description: "Support available during internal transfers.",
      icon: "🚚",
    },
    {
      title: "Workflows",
      description: "Personal or company device usage guidelines.",
      icon: "📱",
    },
    {
      title: "Sales Portal",
      description: "Professional use and security guidelines.",
      icon: "✉️",
    },
  ];

  const navigate = useNavigate();

  // Improved scroll handler with better sensitivity
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDifference = currentScrollY - lastScrollY;

      // Minimum threshold to prevent micro-scrolls from triggering
      if (Math.abs(scrollDifference) < 10) return;

      // Show navbar when:
      // 1. Scrolling up significantly (at least 50px)
      // 2. Near the top of the page (within 50px)
      if (scrollDifference < -50 || currentScrollY < 50) {
        setIsNavbarVisible(true);
      }
      // Hide navbar when:
      // 1. Scrolling down significantly (at least 80px)
      // 2. Not near the top of the page (more than 100px from top)
      else if (scrollDifference > 80 && currentScrollY > 100) {
        setIsNavbarVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar with scroll behavior */}
      <Navbar isVisible={isNavbarVisible} />

      {/* Fixed Header - positioned below navbar with reduced height */}
      <div
        className="fixed left-0 right-0 bg-white z-40 "
        style={{
          top:  "0px",
          transition: "top 0.3s ease-in-out",
        }}
      >
        <div className="px-3 sm:px-4 lg:px-10 py-2">
          {/* Header - reduced gap and sizing */}
          {/* <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0"> */}
            {/* <CompanySelect country={user?.country} /> */}
          {/* </div> */}

          {/* Action buttons section - reduced margin */}
          {/* <div className="mt-2 sm:mt-3"> */}
          {/* Mobile Layout */}
          {/* <div className="block sm:hidden space-y-2">
              <div className="flex items-center gap-2">
                <button onClick={() => navigate('/')} className="flex items-center justify-center px-3 py-2 shadow-[0px_0px_2.86px_0px_#00000040] rounded-[10px] h-8 min-w-[32px]">
                  <img src="assets/clarity_arrow-line.svg" alt="Arrow Left" className="w-4 h-4" />
                </button>
                <button className="flex-1 bg-primaryGreen flex py-2 px-4 font-medium text-white rounded-lg gap-2 items-center text-sm justify-center h-8">
                  <Download color="white" size={14} />
                  Download All Policies (PDF)
                </button>
              </div>
            </div> */}

          {/* Desktop Layout */}
          {/* <div className="hidden sm:flex items-center justify-between w-full">
              <button onClick={() => navigate('/')} className="flex items-center justify-center px-3 py-2 shadow-[0px_0px_2.86px_0px_#00000040] rounded-[10px] h-9">
                <img src="assets/clarity_arrow-line.svg" alt="Arrow Left" />
              </button>

              <button className="bg-primaryGreen flex py-2 px-5 font-medium text-white rounded-lg gap-2 items-center text-sm lg:text-base">
                <Download color="white" size={18} />
                Download All Policies (PDF)
              </button>
            </div> */}
          {/* </div> */}
        </div>
      </div>

      {/* Main Content Area - This will be clipped to prevent cards from showing in header area */}
      <div
        className="flex-1 relative"
        style={{
          marginTop: isNavbarVisible ? "180px" : "100px",
          transition: "margin-top 0.3s ease-in-out",
        }}
      >
        {/* Scrollable Policy Cards Section with proper clipping */}
        <div className="h-full overflow-y-auto pb-16 relative">
          {/* Invisible overlay to clip cards in header area */}
          <div
            className="fixed left-0 right-0 bg-white z-30 pointer-events-none"
            style={{
              top: 0,
              height: isNavbarVisible ? "180px" : "100px",
              transition: "height 0.3s ease-in-out",
            }}
          />

          <div className="px-3 sm:px-4 lg:px-10  relative z-20">
            {/* Title with subtitle */}
            <div className="mb-6 sm:mb-8 md:mb-10 text-center sm:text-left">
              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-black mb-2 sm:mb-3 leading-tight">
                <span className="text-navgreen">Select</span> Your Choice...
              </h1>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 font-medium leading-relaxed max-w-4xl">
                Everything you need to know about how we work, communicate, and
                collaborate.
              </p>
            </div>

            {/* Policies Section */}
            <div className="flex flex-col md:grid-cols-3 md:grid gap-5 sm:grid-cols-2 sm:grid mb-16">
              {getLinksByCompany(user?.company)?.map((item, index) => {

                return <DashboardItem key={index} item={item} />;
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Fixed Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-white z-50 shadow-lg">
        <div className="px-3 sm:px-4 lg:px-10 py-4">{/* <ChatWidget /> */}</div>
        <Footer />
      </div>
    </div>
  );
};

export default Dashboard;
